import isUndefined from 'lodash/isUndefined';
import omitBy from 'lodash/omitBy';

import { InitialValues, ValidationErrors } from 'forms/types';
import { composeValidators, isDOBRangeValid, isPresent, isZipCode } from 'forms/validators/utils';

import { BasicInfoFormValues } from '../../Info/form/types';

const validate = ({ dateOfBirth, gender, zipCode }: InitialValues<BasicInfoFormValues>) =>
  omitBy<ValidationErrors<BasicInfoFormValues>>(
    {
      gender: isPresent(gender),
      dateOfBirth: composeValidators(isPresent, isDOBRangeValid)(dateOfBirth),
      zipCode: composeValidators(isPresent, isZipCode)(zipCode),
    },
    isUndefined
  );

export default validate;
